import { getAuth } from './connectionState'
import {
  AppRequestOptions,
  deleteItem,
  get,
  getImage,
  post,
} from './httpsWrappers'
export interface IApiClient {
  post: <T>(
    domain: string,
    path: string,
    body: object,
    options: AppRequestOptions,
  ) => Promise<T>
  get: <T>(
    domain: string,
    path: string,
    options: AppRequestOptions,
  ) => Promise<T>
  getImage: (url: string, options: AppRequestOptions) => Promise<Blob>
  deleteItem: (
    domain: string,
    path: string,
    options: AppRequestOptions,
  ) => Promise<void>
}

const getAppRequestOptions = async (
  options?: AppRequestOptions,
): Promise<AppRequestOptions> => {
  if (options?.noAuthorization) {
    return options
  }
  if(!options || !options.sessionToken || !options.userId || !options.deviceCode) {
    return getAuth()
  }
  return options
}

export const ApiClient: IApiClient = {
  post: async <T>(
    domain: string,
    path: string,
    body: object,
    options: AppRequestOptions,
  ): Promise<T> => {
    return post(domain, path, body, await getAppRequestOptions(options))
  },
  get: async <T>(
    domain: string,
    path: string,
    options: AppRequestOptions,
  ): Promise<T> => {
    return get(domain, path, await getAppRequestOptions(options))
  },
  getImage: async (url: string, options: AppRequestOptions): Promise<Blob> => {
    return getImage(url, await getAppRequestOptions(options))
  },
  deleteItem: async (
    domain: string,
    path: string,
    options: AppRequestOptions,
  ): Promise<void> => {
    return deleteItem(domain, path, await getAppRequestOptions(options))
  },
}
